import React, { useEffect, useState } from "react";
import { Outlet, Navigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase";

function PrivateRoute() {
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      setUser(u || null);
    });

    return () => unsub();
  }, []);

  if (user === undefined) {
    return <div style={{ padding: 20 }}>Checking login...</div>;
  }

  return user ? <Outlet /> : <Navigate to="/" replace />;
}

export default PrivateRoute;